import React from 'react';

interface InfoIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const InfoIcon: React.FC<InfoIconProps> = ({
  width = 18,
  height = 18,
  fill = '#292929'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="1.25 1.25 17.5 17.5"
      fill="none"
    >
      <path
        d="M10 18.75C5.1748 18.75 1.25 14.8252 1.25 10C1.25 5.1748 5.1748 1.25 10 1.25C14.8252 1.25 18.75 5.1748 18.75 10C18.75 14.8252 14.8252 18.75 10 18.75ZM10 2.75C6.00195 2.75 2.75 6.00195 2.75 10C2.75 13.998 6.00195 17.25 10 17.25C13.998 17.25 17.25 13.998 17.25 10C17.25 6.00195 13.998 2.75 10 2.75Z"
        fill={fill}
      />
      <path
        d="M10.0006 5.26036C10.2313 5.25223 10.456 5.33423 10.6273 5.48898C10.9576 5.85403 10.9576 6.41 10.6273 6.77505C10.4579 6.93356 10.2324 7.01813 10.0006 7.01009C9.76426 7.01957 9.53472 6.92974 9.36759 6.76234C9.20552 6.59444 9.11843 6.36802 9.12622 6.13479C9.11384 5.89982 9.19581 5.66964 9.35392 5.49539C9.5275 5.33065 9.76179 5.24551 10.0006 5.26036Z"
        fill={fill}
      />
      <path
        d="M10 15.0625C9.58594 15.0625 9.25 14.7266 9.25 14.3125V9.47754C9.25 9.06348 9.58594 8.72754 10 8.72754C10.4141 8.72754 10.75 9.06348 10.75 9.47754V14.3125C10.75 14.7266 10.4141 15.0625 10 15.0625Z"
        fill={fill}
      />
    </svg>
  );
};

export default InfoIcon;
